import React from 'react';
import { PropTypes } from 'prop-types';
import { alpha, Chip as MuiChip, makeStyles } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import { palette } from '../../settings/themes/colors';

const CHIP_MAX_WIDTH = 240;

const useFilterChipStyles = makeStyles(() => ({
  root: {
    height: 'auto',
    borderRadius: 4,
    padding: '3px 4px',
    backgroundColor: palette.captudataBlue,
    border: `1px solid ${alpha(palette.white, 0.4)}`,
    color: palette.white,
    width: 'fit-content',
    maxWidth: CHIP_MAX_WIDTH
  },
  label: {
    padding: '0 6px',
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontFamily: 'Nunito',
    fontSize: 14,
    fontWeight: 500,
    lineHeight: 'normal',
    letterSpacing: '0.15px',
    whiteSpace: 'nowrap'
  },
  deleteIcon: {
    width: '16px !important',
    height: '16px !important',
    fontSize: '16px !important',
    margin: 0,
    padding: 0,
    color: palette.white,
    '&:hover': {
      color: palette.artic
    }
  }
}));

export const FilterChip = ({ label, onDelete, classes: classesOverride, ...props }) => {
  const classes = useFilterChipStyles();
  const overrideRoot = (classesOverride || {}).root;
  const overrideDeleteIcon = (classesOverride || {}).deleteIcon;

  return (
    <MuiChip
      classes={{ root: overrideRoot || classes.root, label: classes.label, deleteIcon: overrideDeleteIcon || classes.deleteIcon }}
      label={label}
      onDelete={onDelete}
      deleteIcon={onDelete ? <CancelIcon fontSize="small" /> : undefined}
      {...props}
    />
  );
};

FilterChip.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.node]).isRequired,
  onDelete: PropTypes.func,
  classes: PropTypes.shape({
    root: PropTypes.string,
    deleteIcon: PropTypes.string
  })
};
